import { render, staticRenderFns } from "./safeCheckActivity.vue?vue&type=template&id=e2831a90&scoped=true"
import script from "./safeCheckActivity.vue?vue&type=script&lang=js"
export * from "./safeCheckActivity.vue?vue&type=script&lang=js"
import style0 from "./safeCheckActivity.vue?vue&type=style&index=0&id=e2831a90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2831a90",
  null
  
)

export default component.exports